import React, { createContext, useState, useContext, useEffect } from "react";

// Create the UserContext
const UserContext = createContext(null);

// Create a provider component
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [activeRoles, setActiveRoles] = useState([]);

  // Load user data from localStorage on initialization
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    const roles = localStorage.getItem('activeRoles');
    if (roles) {
      setActiveRoles(JSON.parse(roles));
    }
  }, []);

  // Update localStorage whenever user changes
  const updateUser = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  // Update localStorage whenever roles changes
  const updateActiveRoles = (rolesData) => {
    setActiveRoles(rolesData);
    localStorage.setItem('activeRoles', JSON.stringify(rolesData));
  };

  return (
    <UserContext.Provider value={{ user, setUser: updateUser, activeRoles, setActiveRoles: updateActiveRoles, }}>
      {children}
    </UserContext.Provider>
  );
};

// Custom hook to use the UserContext
export const useUser = () => {
  return useContext(UserContext);
};
